module.exports = __webpack_public_path__ + "img/clock.e218c975.svg";